import { ProfilerProduct } from "../../../../types/ProfilerProduct";

type BeautyProfilerFavoriteFragranceProps = {
  topFetiche: ProfilerProduct | null;
};

export const BeautyProfilerFavoriteFragrance = 
  ({ topFetiche }: BeautyProfilerFavoriteFragranceProps) => {
    return (
      <>
        <div>
          <p className="text-[#050505] text-center font-garamond-italic text-[20px] italic font-normal">
            Your Favorite Fragrance
          </p>
          <h1 className="text-[#CE0A2C] text-center font-bebas-kai text-[40px] font-normal">
            {topFetiche?.label}
          </h1>
        </div>
        <div className="text-[#050505] text-justify font-minion text-[20px] font-normal leading-[150%]">
          {topFetiche?.description}
        </div>
      </>
    );
  };